import Route from '@ember/routing/route';
import { service } from '@ember/service';
import ContactsCache, {
  type ContactCustomPropertyInfo,
} from 'donor-elf-web/services/contacts-cache';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export interface PropertiesIndexRouteModel {
  propertyInfos: {
    property: ContactCustomPropertyInfo;
    contactCount: number;
  }[];
}

export default class PropertiesIndexRoute extends Route {
  @service declare contactsCache: ContactsCache;
  @service declare navbarSettings: NavbarSettingsService;

  beforeModel() {
    this.navbarSettings.title = 'Edit Property Definitions';
  }

  model(): PropertiesIndexRouteModel {
    return {
      propertyInfos: [
        {
          property: this.contactsCache.groupsContactCustomPropertyInfo,
          contactCount: this.contactsCache.contacts.filter((x) => x.hasGroups)
            .length,
        },
        ...this.contactsCache.customProperties.map((property) => {
          return {
            property,
            contactCount: this.contactsCache.contacts.filter(
              (x) => x.customPropertiesByLabel[property.l] != null,
            ).length,
          };
        }),
      ],
    };
  }
}
